import {
  addFieldData,
  addSubStep,
  setMessage,
  setReturnedValue,
  stopLoading
} from "../../actions";
import { processAppointments } from "../appointment";
import { fetcher, getReturnedValue, goToNextStep } from "../fetcher";
import { formatPraticiensAnesthesie } from "../formatter";
import * as CalendarHelper from "../calendar";
import { DateTime } from "luxon";

export const getUrls = () => ({
  getResponse: "ajax/get_reponse_react.php",
  getQuestion: "ajax/get_question_react.php",
  connexion: "ajax/connexion_widget.php",
  subscribe: "ajax/inscription_widget_ajax.php",
  getUser: "ajax/get_info_user.php",
  confirm: "ajax/confirmation_rdv.php",
  alterAppointment: "ajax/modification_user_rdv.php",
  summaryReport: "ajax/recap_rdv.php",
  faq: "cache_ajax/faq_widget.php",
  listUserComplete: "ajax/get_user_liste_complete_ajax.php",
  addUserAnnex: "ajax/add_user_annexe.php",
  editListUsers: "ajax/modification_liste_user_rdv.php",
  recapRdv: "ajax/recap_rdv_ajax.php",
  forgotPassword: "envoi_mdp_compte_widget.php",
  lbv: "ajax/api_lbv.php",
  infoRdvToken: "ajax/info_rdv_token.php",
  contact: "ajax/nous_contacter.php",
  controlPriorityCode: "ajax/ctrl_validation_code.php"
});

export const getProfessionAnesthesie = () => {
  return dispatch => {
    fetcher()
      .get("ajax/widget_liste_profession_anesthesiste.php")
      .then(response => response.json())
      .then(json => {
        dispatch(
          goToNextStep(
            "idProfession",
            json,
            json.length === 1,
            json.length === 1 ? json[0].id : null
          )
        );
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getPraticiensAnesthesie = () => {
  return dispatch => {
    const professionId = getReturnedValue("idProfession");
    if (professionId) {
      fetcher()
        .get("ajax/get_praticien_anesthesiste.php", {
          searchParams: {
            idprofession: professionId
          }
        })
        .then(response => response.json())
        .then(json => {
          dispatch(
            goToNextStep(
              "idPraticien",
              json,
              json.length === 1,
              json.length === 1 ? json[0].id : null
            )
          );
          if (json.length === 1) {
            const formattedData = formatPraticiensAnesthesie(json);
            dispatch(
              setReturnedValue({ idquestion: formattedData[0].dataValue })
            );
          }
        })
        .catch(() => {
          dispatch(stopLoading());
        });
    }
  };
};

export const getAvailableAppointment = () => {
  return (dispatch, getState) => {
    const searchParams = {
      idunique: getReturnedValue("idquestion"),
      dateintervention: getReturnedValue("dateintervention"),
      idpraticien: getReturnedValue("idPraticien"),
      jour_perso: getReturnedValue("day"),
      heure_perso: getReturnedValue("timeSlot"),
      quand_perso: +getReturnedValue("customWhen", 0),
      nb_semaine: getReturnedValue("inWeeks", 1),
      num_mois: getReturnedValue("fromMonth", 1),
      filtreall: getReturnedValue("fullSearch")
    };
    fetcher()
      .get("ajax/rdv_disponible_sequencage_anesthesite.php", { searchParams })
      .then(response => response.json())
      .then(json => {
        const subStep = processAppointments(json, true);
        dispatch(addSubStep(getState().activeStep.step, subStep, false));
        if (json.length === 1 && json[0].success === 0) {
          dispatch(setMessage(json[0].message_error));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getAvailableAppointmentCalendar = () => {
  return (dispatch, getState) => {
    fetcher()
      .get("ajax/rdv_disponible_sequencage_anesthesite_calendar.php", {
        searchParams: {
          idunique: getReturnedValue("idquestion"),
          dateintervention: getReturnedValue("dateintervention"),
          idpraticien: getReturnedValue("idPraticien"),
          jour_perso: getReturnedValue("day"),
          heure_perso: getReturnedValue("timeSlot"),
          quand_perso: +getReturnedValue("customWhen", 0),
          nb_semaine: getReturnedValue("inWeeks", 1),
          num_mois: getReturnedValue("fromMonth", 1),
          filtreall: getReturnedValue("fullSearch")
        }
      })
      .then(response => response.json())
      .then(json => {
        // init stack with current date
        CalendarHelper.add(DateTime.local(), true);
        const subStep = processAppointments(json);
        dispatch(addSubStep(getState().activeStep.step, subStep, false));

        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const nextAppointments = date => {
  return dispatch => {
    fetcher()
      .get("ajax/rdv_disponible_sequencage_anesthesite_calendar.php", {
        searchParams: {
          idunique: getReturnedValue("idquestion"),
          dateintervention: getReturnedValue("dateintervention"),
          idpraticien: getReturnedValue("idPraticien"),
          jour_perso: getReturnedValue("day"),
          heure_perso: getReturnedValue("timeSlot"),
          quand_perso: +getReturnedValue("customWhen", 0),
          nb_semaine: getReturnedValue("inWeeks", 1),
          num_mois: getReturnedValue("fromMonth", 1),
          datesemaine: date
        }
      })
      .then(response => response.json())
      .then(json => {
        dispatch(addFieldData("appointment", json));
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};
